// Native only.

import { type UseAutoAdjustBrightnessProps } from './useAutoAdjustBrightness.types';

export const useAutoAdjustBrightness = (
  _props: UseAutoAdjustBrightnessProps,
) => {};
